import { createConsumer, createSubscriber, IConsumer, IEvent } from '@cian/events-log';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../../types/referrer/store';
import { getUser } from '../user';

interface IViewData {
  headingType: string | undefined;
}

export interface IRequestAuthenticationParameters {
  viewData?: IViewData;
  onSuccess?(): void;
  onCloseNoAuth?(): void;
}

const TOPIC_USER = 'user';

type TConsumerSingleton = (() => IConsumer) & { _instance?: IConsumer };

const getUserConsumer: TConsumerSingleton = (): IConsumer => {
  if (!getUserConsumer._instance) {
    getUserConsumer._instance = createConsumer({ topic: TOPIC_USER });
  }

  return getUserConsumer._instance;
};

export const subscribeOnAuthentification = createAsyncThunk<void, IRequestAuthenticationParameters, IThunkApi>(
  'authentication/subscribeOnAuthentification',
  async (parameters, _thunkApi) => {
    const { dispatch, getState } = _thunkApi;

    if (typeof window !== 'undefined') {
      const consumer = getUserConsumer();

      const userSubscriber = createSubscriber(async (event: IEvent<unknown>) => {
        if (event.type === 'authenticated') {
          if (getState().user.userId) {
            consumer.unsubscribe(userSubscriber);

            return;
          }

          await dispatch(getUser());

          // @ts-ignore
          if (window.__reloadHeader__) {
            // @ts-ignore
            window.__reloadHeader__();
          }

          if (parameters && parameters.onSuccess) {
            parameters.onSuccess();
          }

          consumer.unsubscribe(userSubscriber);

          return;
        }

        if (event.type === 'authentication_modal_closed') {
          if (parameters && parameters.onCloseNoAuth) {
            parameters.onCloseNoAuth();
          }

          consumer.unsubscribe(userSubscriber);
        }
      });

      consumer.subscribe(userSubscriber);
    }
  },
);
